export const SYSTEM_SETTINGS_ENDPOINTS = {
  SYSTEM_SETTINGS: (pbxId: number) => `/app/v1/pbx/${pbxId}/system-settings/`,
  PLAYLISTS: (pbxId: number) => `/app/v1/pbxes/${pbxId}/playlists/`,
  PHONE_NUMBERS: '/app/v1/phone-numbers/',
  EXTENSIONS: '/app/v1/extensions/',
  VIRTUAL_FAX_MACHINES: (pbxId: number) =>
    `/app/v1/pbxes/${pbxId}/virtual-fax-machines/`,
} as const
